import { render, staticRenderFns } from "./week-overview-header.vue?vue&type=template&id=f6f06126&"
import script from "./week-overview-header.ts?vue&type=script&lang=ts&"
export * from "./week-overview-header.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports